import { useEffect, useRef } from 'react';

/**
 * Closes a popover on a click outside it or on Escape. Returns the ref to put
 * on the element that counts as "inside", trigger included.
 */
export function useDismissable<T extends HTMLElement = HTMLDivElement>(open: boolean, close: () => void) {
  const containerRef = useRef<T>(null);
  useEffect(() => {
    if (!open) return;
    const onPointerDown = (event: MouseEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) close();
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') close();
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [close, open]);
  return containerRef;
}
